import { render, staticRenderFns } from "./TaxCalendar.vue?vue&type=template&id=6a76c1a7&scoped=true&"
import script from "./TaxCalendar.vue?vue&type=script&lang=ts&"
export * from "./TaxCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./TaxCalendar.vue?vue&type=style&index=0&id=6a76c1a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76c1a7",
  null
  
)

export default component.exports